import pub from './../public'
const type = pub.getLang();
const language = {
  "zh-hk": {
    shortRent: '短租',
    sublet: '分租',
    messageTerms:["當你按下提交留言按鈕","即表示你已閱讀並同意House 730之","留言條款"],
    alertM:['永久刪除留言?','取消','確定'],
    selectAction:"選擇動作",
    messageInfo: "請輸入留言內容",
    manageMessages: "管理樓盤問答",
    myQuestion: "我的提問",
    myReplies: "買家留言",
    yourMessage: "你的留言",
    ownerReply: "業主回覆",
    questionMessage: "買家留言",
    myReply: "我的回覆",
    manage: "管理 >",
    noMore: "沒有更多了",
    loading: "加載中",
    messageReply: "回覆留言",
    messageChange: "更改留言",
    messageDelete: "刪除留言",
    messageDeleteIs: "是否確認刪除留言",
    cancel: "取消",
    contactInfo: "聯絡方法",
    contactNumber: "請輸入聯絡方法",
    submit: '提交留言',
    committing: '提交中',
    submittedSuccessfully: '提交成功',
    successfullyDeleted: "刪除成功",
    remark:"收藏備註：",
  },
  "zh-cn": {
    ShortRent: '短租',
    sublet: '分租',
    messageTerms:["当你按下提交留言按钮","即表示你已阅读并同意House 730之","留言条款"],
    alertM:['永久删除留言?','取消','确定'],
    selectAction:"选择动作",
    messageInfo: "请输入留言内容",
    manageMessages: "管理楼盘问答",
    myQuestion: "我的提问",
    myReplies: "买家留言",
    yourMessage: "你的留言",
    ownerReply: "业主回复",
    questionMessage: "买家留言",
    myReply: "我的回复",
    manage: "管理 >",
    noMore: '沒有更多了',
    loading: "加载中",
    messageReply: "回复",
    messageChange: "更改留言",
    messageDelete: "删除留言",
    messageDeleteIs: "是否确认删除留言",
    cancel: "取消",
    contactInfo: "联络方法",
    contactNumber: "请输入联络方法",
    submit: "提交留言",
    committing: '提交中',
    submittedSuccessfully: '提交成功',
    successfullyDeleted: "删除成功",
    remark:"收藏备注：",

  },
  "en-us": {
    ShortRent: 'Short-term',
    sublet: 'Share',
    messageTerms:["When you press the submit message button","this means that you have read and agreed to the House 730","Message Terms"],
    alertM:['Delete Message?','Cancel','Ok'],
    selectAction:"Select Action",
    messageInfo: "Please enter the message content",
    manageMessages: "Manage Messages",
    myQuestion: "My Questions",
    myReplies: "Buyer Messages",
    // myReplies: "My Replies",
    yourMessage: "Your Message",
    ownerReply: "Landlord Reply",
    questionMessage: "Buyer Messages",
    // questionMessage: "Message",
    myReply: "Reply",
    manage: "Manage >",
    noMore: "No More",
    loading: "loading",
    messageReply: "Reply message",
    messageChange: "Edit Message",
    messageDelete: "Delete Message",
    messageDeleteIs: "Whether to confirm the deletion of the message",
    cancel: "Cancel",
    contactInfo: "Contact Phone no.",
    contactNumber: "Please enter the contact method",
    submit: "submit",
    committing: 'committing',
    submittedSuccessfully: 'Submitted Successfully',
    successfullyDeleted: "Successfully Deleted",
    remark:"Bookmark Property Notes：",
  },
}
export default language[type]